// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-0063eace]{color:#1c2634;font-size:18px;font-weight:600;text-align:center}.content[data-v-0063eace]{display:flex;flex-direction:column;padding:20px}.content>p[data-v-0063eace]{font-size:18px;font-weight:500;line-height:34px}.content>p>span[data-v-0063eace]{font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
